
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/PanelFrame/PanelFrame.scss.css.virtualfile';
        module.exports = {"container":"_container_t2d0j_1","contentContainer":"_contentContainer_t2d0j_5"};